import { EExportType } from "@rentiohq/shared-frontend/dist/reduxV2/exportFile";

export interface IExtraData {
  exportTypes: EExportType[];
  // Opened from the recurring exports, so a recurring frequency is the default.
  isRecurring?: boolean;
  // False once the office has the maximum number of recurring exports: only "once" is offered.
  canSchedule: boolean;
}

export enum EField {
  ExportType = "exportType",
  ExportFileType = "exportFileType",
  Frequency = "frequency",
  RunWeekday = "runWeekday",
  RunMonth = "runMonth",
  RunDayOfMonth = "runDayOfMonth",
}

// A one-off export next to the schedule frequencies in the same choice.
export const FREQUENCY_ONCE = "ONCE";

// The form's id for "the last day of the month". The API's value is LAST_DAY_OF_MONTH (-1), but
// SelectField reads -1 as "nothing selected", so the form uses its own id and the submit maps it.
export const LAST_DAY_OPTION = "LAST";
